import {
  BLUR_ACT_RECORD_DATA,
  CHANGE_ACT_RECORD_DATA,
  RESET_ACT_RECORD_DATA,
  GET_REG_PLACE_SUGGESTIONS_SUCCESS,
  GET_REG_PLACE_SUGGESTIONS,
  GET_REG_PLACE_SUGGESTIONS_ERROR
} from '../constants';

export const changeActRecordData = payload => ({
  type: CHANGE_ACT_RECORD_DATA,
  payload
});

export const blurActRecordData = payload => ({
  type: BLUR_ACT_RECORD_DATA,
  payload
});

export const getRegPlaceSuggestions = () => ({
  type: GET_REG_PLACE_SUGGESTIONS
});

export const getRegPlaceSuggestionsSuccess = payload => ({
  type: GET_REG_PLACE_SUGGESTIONS_SUCCESS,
  payload
});

export const getRegPlaceSuggestionsError = () => ({
  type: GET_REG_PLACE_SUGGESTIONS_ERROR
});

export const resetActRecordData = () => ({
  type: RESET_ACT_RECORD_DATA
});
